<template>
  <b-card>
    <h1>Type visits of {{ getCurrentMonth() }} - {{ total }}</h1>
    <vue-apex-charts :options="chartOptions" :series="series" type="pie" />
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'
import { chartFromPatientsByType } from '@/core/utils/patientsByTypeChart'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
    dataDashboard: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 400,
          width: '100%',
        },
        tooltip: {
          theme: 'custom',
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#3C231D'],
          },
          dropShadow: {
            enabled: false,
          },
        },
        labels: [],
        colors: [
          '#fbd5cc',
          '#ffc699',
          '#cadbbb',
          '#91b3a5',
          '#a6c6dd',
          '#ccdafd',
          '#c5dff0',
          '#f8e6b4',
        ],
      },
      series: [],
      total: 0,
      isSmallScreen: window.innerWidth <= 768,
    }
  },
  watch: {
    dataDashboard: {
      immediate: true,
      handler() {
        this.updateChartData()
      },
    },
  },
  methods: {
    updateChartData() {
      const patientsByType =
        (this.dataDashboard && this.dataDashboard.patients_by_type) || []

      // Preferir patients_by_type (tipos 9–12). Fallback: all_patients Insurance-*
      if (patientsByType.length > 0) {
        const chart = chartFromPatientsByType(patientsByType, {
          shortLabels: this.isSmallScreen,
          lane: 'insurance',
        })
        this.chartOptions = { ...this.chartOptions, labels: chart.labels }
        this.series = chart.series
        this.total = chart.total
        return
      }

      const counts = {
        'INS-NP': 0,
        'INS-NC': 0,
        'INS-F/U': 0,
        'INS-R/S': 0,
      }
      const allPatients =
        (this.dataDashboard && this.dataDashboard.all_patients) || []
      allPatients.forEach(patient => {
        const typeVisit = (patient && patient.type_visit) || ''
        if (!typeVisit.startsWith('Insurance-')) return
        const visitType = typeVisit.replace('Insurance-', '')
        const map = {
          NP: 'INS-NP',
          NC: 'INS-NC',
          'F/U': 'INS-F/U',
          'R/S': 'INS-R/S',
        }
        const key = map[visitType]
        if (key) counts[key] += patient.count || 1
      })

      const labelsMap = this.isSmallScreen
        ? {
            'INS-NP': 'INS-NP',
            'INS-NC': 'INS-NC',
            'INS-F/U': 'INS-F/U',
            'INS-R/S': 'INS-R/S',
          }
        : {
            'INS-NP': 'Insurance NP',
            'INS-NC': 'Insurance NC',
            'INS-F/U': 'Insurance Follow Up',
            'INS-R/S': 'Insurance Result',
          }

      const labels = []
      const series = []
      Object.keys(counts).forEach(prefix => {
        const n = counts[prefix]
        if (n <= 0) return
        labels.push(`${labelsMap[prefix]}: ${n}`)
        series.push(n)
      })

      this.chartOptions = { ...this.chartOptions, labels }
      this.series = series
      this.total = series.reduce((a, b) => a + b, 0)
    },
    getCurrentMonth() {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      return months[new Date().getMonth()]
    },
  },
}
</script>
